/**
 * CustomSelect class for creating a custom dropdown select element
 *
 * @class
 */

export default class CustomSelect {
    /**
     * Creates an instance of CustomSelect.
     * @param {string} wrappers - CSS selector used to select all the wrapper elements that contain the select elements
     * @param {string} headingClass - CSS selector used to select the heading element of the custom select element
     * @param {string} optionsClass - CSS selector used to select the options element of the custom select element
     */

    constructor(wrappers = '.custom_select__wrapper', headingClass = '.custom_select__title', optionsClass = '.custom_select__options') {
        this.wrappers = document.querySelectorAll(wrappers)
        this.headingClass = headingClass
        this.optionsClass = optionsClass

        this.visibleClass = '--visible'
        this.activeClass = '--active'
        this.positionalClass = '--above'

        this.init();
    }

    init() {
        this.wrappers.forEach(wrapper => {
            const heading = wrapper.querySelector(this.headingClass)
            const options = wrapper.querySelector(this.optionsClass)
            const select = wrapper.querySelector('select');
        
            // Toggle active class on wrapper when heading is clicked
            heading.addEventListener('click', () => {
                wrapper.classList.toggle(this.activeClass)

                // Change position of Options element
                if (this.isElementOutsideBottomOfViewport(options)) {
                    this.addOptionsPosition(options)
                } else {
                    this.resetOptionsPosition(options)
                }
            })
        
            // Remove active class from wrapper if click was outside it
            document.addEventListener('click', e => {
                if (!wrapper.contains(e.target)) {
                    wrapper.classList.remove(this.activeClass)
                    this.resetOptionsPosition(options)
                }
            })
        
            // Update heading text, close the wrapper and go to url when an option is clicked
            options.addEventListener('click', e => {
                const option = e.target
                const url = option.dataset.url

                if (option && url) {
                    wrapper.classList.remove(this.activeClass)
                }
            })

            // Loop through options and add event listener to select option on click
            options.querySelectorAll('[role=option]').forEach(option => {
                option.addEventListener('click', () => {
                    // Remove selected class from all options
                    options.querySelectorAll('[role=option]').forEach(option => {
                        option.classList.remove('selected');
                        option.setAttribute('aria-selected', 'false');
                    });
                    
                    // Add selected class to clicked option
                    option.classList.add('selected');
                    option.setAttribute('aria-selected', 'true');

                    // Update hidden select value
                    select.value = option.dataset.url.trim();

                    // Go to URL selected
                    window.location.href = option.dataset.url

                    // Update heading text
                    heading.textContent = option.textContent.trim();
                });
            });

            select.addEventListener('change', (e) => {
                const selectedOption = e.target.selectedOptions[0];
                const selectedUrl = selectedOption.value;

                window.location.href = selectedUrl;
            });
        })
    }

    addOptionsPosition(el) {
        el.classList.add(this.positionalClass)
    }

    resetOptionsPosition(el) {
        el.classList.remove(this.positionalClass)
    }

    isElementOutsideBottomOfViewport(el) {
        const rect = el.getBoundingClientRect()
        const isBelowWindow = rect.bottom > window.innerHeight

        return isBelowWindow
    }
    
}